import { Router } from '@angular/router';
import { ExamsTemplateContainerService } from '../../forms/examns-template-container/exams-template-container.service';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { TooltipModule } from 'primeng/tooltip';
import { DatabaseService } from '@app/database/database.service';
import { BackgroundSyncService } from '@app/helpers/backgroundSync.service'; 

@Component( {
  selector: 'app-examens-card-item',
  templateUrl: './examens-card-item.component.html',
  styleUrls: [ './examens-card-item.component.scss' ],
} )
export class ExamensCardItemComponent implements OnInit {
  @Input() card: any;
  @Input() isLastCardItem: boolean;
  @Input() prestador: string;
  @Input() actualizacionAsistencia: any;
  motivoCierre: any;
  presentismoCierre: any;
  ausentismoCierre: any;
  @Output() dismissCardCloseExam: EventEmitter<any> = new EventEmitter<any>();
  @Output() refreshList = new EventEmitter<any>();
  tooltipIsVisible: boolean;
  displayModalAnularAusencia = false;
  displayModalPresente = false;
  displayModalFirma = false;
  displayModalAusente = false;
  displayModalCargaExamenPDF = false;
  labelPresentismo: string;
  trabajadorFirmaB64; 
  trabajadorFirmaSigString;
  asistencia;
  presente = false;

  constructor(
    private examFormService: ExamsTemplateContainerService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private tooltipModule: TooltipModule,
    private dbService: DatabaseService,
    private backgroundSyncService: BackgroundSyncService,
  ) {

  }

  asistenciaUpdate(asistencia: any){
    this.asistencia = asistencia[0].asistencia;
    if(this.asistencia === 'Ausente'){
      this.motivoCierre = asistencia[0].motivo;
      this.presente = false;
    }
    
    if(this.asistencia === 'Presente'){
      this.presente = true;
      this.motivoCierre = null;
    }

    if(this.asistencia === 'Anular Ausencia'){
      this.presente = false;
      this.motivoCierre = null;
      this.asistencia = null;
      this.labelPresentismo = 'Asistencia';
    }
  }

  async ngOnInit(): Promise<void> {
    const cardConCambios = await this.dbService.applyPendingPresentismoChanges(this.card);
    
    this.card = cardConCambios;
    
    if (this.card.asistencia) {
      this.asistencia = this.card.asistencia;
      
      if (this.card.asistencia === 'Presente') {
        this.presente = true;
        this.motivoCierre = null;
      } else if (this.card.asistencia === 'Ausente') {
        this.presente = false;
      } else {
        this.presente = false;
        this.motivoCierre = null;
      }
    } else {
      this.asistencia = this.card.asistencia;
      this.checkFirmaPresente();   
      
      if (this.presente) {
        this.motivoCierre = null;
        this.asistencia = 'Presente';
      } else if (this.card.motivoCierre) {
        this.motivoCierre = this.card.motivoCierre;
        this.presente = false;
        this.asistencia = 'Ausente';
      }
    }
    
    this.getTiposMotivoCierre();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.actualizacionAsistencia.currentValue && this.card.id == changes.actualizacionAsistencia.currentValue.id){
      const cambio = changes.actualizacionAsistencia.currentValue;
      this.asistencia = cambio.asistencia;
      
      if(this.asistencia === 'Ausente'){
        this.motivoCierre = cambio.motivo;
        this.presente = false;
      } else if(this.asistencia === 'Presente'){
        this.presente = true;
        this.motivoCierre = null;
      } else if(this.asistencia === 'Anular Ausencia'){
        this.presente = false;
        this.motivoCierre = null;
        this.asistencia = null;
        this.labelPresentismo = 'Asistencia';
      }
      
    }
  }

  checkFirmaPresente(){
    if(this.card.firmaB64){
      this.presente = true;
    }
  }

  async getTiposMotivoCierre(): Promise<void> {
    const dataFromOffline = await this.dbService.getAllMotivosCierreFromOfflineDB();
    this.motivoCierre = dataFromOffline.filter(
      (motivo) => motivo.codigo === this.card.motivoCierre ? motivo : null
    )[0];
  }

  receivePresentismoCierre( $event ) {
    this.presentismoCierre = $event;
    if(this.presentismoCierre.descripcion === "Presente"){
      this.showModalPresente();
    }
    
    if (this.presentismoCierre.descripcion === "Ausente"){
      this.showModalAusente();
    }

    if (this.presentismoCierre.descripcion === "Anular Ausencia"){
      this.showModalAnularAusencia();
    }
  }

  async loadExam() {
    localStorage.setItem( 'tab', this.card.lote.reevaluacion ? "reevaluacion" : "periodicos" );
    let { categoriaEstudio, tipoEstudio, codigoTipoEstudio, id } = this.card;
    codigoTipoEstudio = tipoEstudio.tipoEstudioCod;
    tipoEstudio = tipoEstudio.descripcion.toLowerCase().replaceAll(' ','-').replaceAll('/','');
    this.examFormService.updateDataExam(this.card);
    categoriaEstudio = await this.getTablaParaObtenerExamen(this.card.lote.reevaluacion);
    this.router.navigate([`examen/${categoriaEstudio}/${tipoEstudio}/${codigoTipoEstudio}/${id}`]);
  }

  async getTablaParaObtenerExamen(isReevaluacion: boolean): Promise<string> {
    if (!isReevaluacion) {
      const resultado = JSON.parse(localStorage.getItem('resultadoPeriodicos'));
      return (resultado.value === 'pordefecto') ? "periodicos" : 'examenesPeriodicosFiltrados';
    } else  {
      const resultado = JSON.parse(localStorage.getItem('resultadoReevaluacion'));
      return (resultado.value === 'pordefecto') ? "reconfirmacion" : 'examenesReconfirmacionFiltrados';
    }
  }

  async deleteExam(): Promise<void> {
    const removeFromTable = `examenesPorEnviar`;
    await this.dbService.deleteItemFromTable( this.card.id, removeFromTable );
    this.backgroundSyncService.updateTabPorEnviar( true );
  }

  mouseEnter(): void {
    this.tooltipIsVisible = true;
  }

  mouseLeave(): void {
    this.tooltipIsVisible = false;
  }

  receiveCloseExam(motivoCierre: any) {
    this.motivoCierre = motivoCierre;
    this.dismissCardCloseExam.emit( { examen: this.card, motivo: motivoCierre } );
  }

  showModalPresente(){
    this.displayModalPresente = true;
  }

  closeModalPresente(){
    this.displayModalPresente = false;
  }

  showModalFirma(){
    this.displayModalFirma = true;
  }

  closeModalFirma(){
    this.displayModalFirma = false;
  }

  showModalAusente(){
    this.displayModalAusente = true;
  }

  closeModalAusente(){
    this.displayModalAusente = false;
  }

  showModalAnularAusencia(){
    this.displayModalAnularAusencia = true;
  }

  closeModalAnularAusencia(){
    this.displayModalAnularAusencia = false;
  }

  showModalCargaExamenPDF(){
    this.displayModalCargaExamenPDF = true;
  }

  closeModalCargaExamenPDF(){
    this.displayModalCargaExamenPDF = false;
  }

  recibirDatosFirma(datos: { trabajadorFirmaB64: string, trabajadorFirmaSigString: string }) {
    this.trabajadorFirmaB64 = datos.trabajadorFirmaB64;
    this.trabajadorFirmaSigString = datos.trabajadorFirmaSigString;
  }
}
